module.exports = __webpack_public_path__ + "static/img/banner1.9dbedf4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/campaign/banner1.jpg
// module id = 7HOh
// module chunks = 0